module.exports = __webpack_public_path__ + "static/media/thumbnail-2.e715c255.png";